var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7668_35909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4766 14.9531H15.6866L15.4066 14.6831C16.3866 13.5431 16.9766 12.0631 16.9766 10.4531C16.9766 6.86313 14.0666 3.95312 10.4766 3.95312C6.88656 3.95312 3.97656 6.86313 3.97656 10.4531C3.97656 14.0431 6.88656 16.9531 10.4766 16.9531C12.0866 16.9531 13.5666 16.3631 14.7066 15.3831L14.9766 15.6631V16.4531L19.9766 21.4431L21.4666 19.9531L16.4766 14.9531ZM10.4766 14.9531C7.98656 14.9531 5.97656 12.9431 5.97656 10.4531C5.97656 7.96312 7.98656 5.95312 10.4766 5.95312C12.9666 5.95312 14.9766 7.96312 14.9766 10.4531C14.9766 12.9431 12.9666 14.9531 10.4766 14.9531Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7668_35909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.976562 0.953125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindIcon);
export default __webpack_public_path__ + "static/media/findIcon.3dfbd1a8c49841270c962dfb053b117f.svg";
export { ForwardRef as ReactComponent };